module.exports = __webpack_public_path__ + "static/media/account_circle_black.e4f0cce0.svg";